'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as Dialog from '@radix-ui/react-dialog';
import { CrossLine, Export2Line } from '@zealy/icons';
import { cn } from '../../utils/cn';
import { Button } from '../Button';
import { LinkCopyGroup } from '../InviteTask/LinkCopyGroup';
import { styles } from './ShareModal.styles';
// https://web.dev/web-share/
export const ShareButton = ({ className, title, description, link }) => {
    const share = () => {
        if (navigator.share) {
            navigator
                .share({
                title,
                text: description,
                url: link,
            })
                .then(() => console.log('Successful share'))
                .catch(error => console.log('Error sharing', error));
        }
    };
    if (!navigator.share)
        return null;
    return (_jsx(Button, { variant: "muted", onClick: share, leftIcon: _jsx(Export2Line, {}), className: className, size: "lg", children: "Share" }));
};
export const ShareModal = ({ className, title, description, link, ...props }) => {
    return (_jsx(Dialog.Root, { ...props, children: _jsxs(Dialog.Portal, { children: [_jsx(Dialog.Overlay, { className: styles.overlay }), _jsxs(Dialog.Content, { className: cn(styles.content, className), children: [_jsxs("div", { children: [_jsx(Dialog.Title, { className: styles.title, children: title }), _jsx(Dialog.Description, { className: styles.description, children: description })] }), _jsx(LinkCopyGroup, { link: link, size: "lg" }), _jsx(ShareButton, { title: title, description: description, link: link }), _jsx(Dialog.Close, { className: styles.close, children: _jsx(Button, { onlyIcon: true, variant: "ghost", leftIcon: _jsx(CrossLine, {}), size: "sm" }) })] })] }) }));
};
